import angular from 'angular';

let ApiaccesslogListController = function (Apiaccesslog, $filter, $scope, $state) {
  let $ctrl = this;
  $ctrl.$scope = $scope;

  angular.extend($ctrl, {
    edit, orderList
  });

  activate();

  function activate() {
    $ctrl.resources = {
      count: 0,
      data: []
    };

    $ctrl.uiState = 'LOADING';

    $ctrl.promise;

    $ctrl.$scope.tableConfig = {
      page: 1,
      limit: 10,
      order: 'updated_at DESC',
      like_search: '',
      like_search_fields: [
        'username',
        'created_at',
        'type'
      ]
    };

    $ctrl.$scope.$watch('tableConfig', () => {
      loadData()
    }, true);
  }

  function edit(item) {
    $state.go('apiaccesslog.edit', { id: item });
  }

  function orderList(field) {
    var tableConfig = $ctrl.$scope.tableConfig;
    if (tableConfig.order) {
      var currentField = tableConfig.order.split(' ')[0];
      var currentOrder = tableConfig.order.split(' ')[1];
      
      if (currentField === field) {
        currentOrder = currentOrder === 'DESC' ? 'ASC' : 'DESC';
        tableConfig.order = currentField + ' ' + currentOrder;  
      } else {
        tableConfig.order = field + ' ' + 'ASC'; 
      }
    } else {
      tableConfig.order = field + ' ' + ' ASC';
    }
  }

  // Local functions
  function loadData() {
    $ctrl.promise = Apiaccesslog
      .load($ctrl.$scope.tableConfig)
      .then(response => {
        $ctrl.resources = response;
        $ctrl.uiState = response.data.length ? 'COMPLETE' : 'EMPTY';
        $ctrl.$scope.$apply();
      })
      .catch(err => {
        console.log('err:' ,  err);
        $ctrl.uiState = 'ERROR';
      });
  }
}

ApiaccesslogListController.$inject = ['Apiaccesslog', '$filter', '$scope', '$state'];

export default ApiaccesslogListController;



// WEBPACK FOOTER //
// ./client/app/components/apiaccesslog/apiaccesslog-list.controller.js